import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PickUpPointMethodSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Row>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Row>
      <Skeleton variant="rounded" width="100%" height={56} />
      <Skeleton variant="rounded" width="100%" height={56} />
    </Styles.Container>
  )
}

export default PickUpPointMethodSkeleton
